import { MsalInterceptorConfiguration } from "@azure/msal-angular";
import {
  BrowserCacheLocation,
  Configuration,
  InteractionType,
  IPublicClientApplication,
  PublicClientApplication
} from "@azure/msal-browser";
import { environment } from "environments/environment";
import { GlobalConstants } from "./constants/global-constants";

const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

const msalConfig: Configuration = {
  auth: {
    clientId: environment.msalConfig.clientId, // This is your client ID
    authority: 'https://login.microsoftonline.com/' + environment.msalConfig.tenantId, // This is your tenant ID
    knownAuthorities: [],
    redirectUri: environment.msalConfig.redirectUri,// This is your redirect URI
    postLogoutRedirectUri: environment.msalConfig.redirectUri + "/login",
    navigateToLoginRequestUrl: false // Prevent automatic navigation to login
  },
  cache: {
    cacheLocation: BrowserCacheLocation.SessionStorage,
    storeAuthStateInCookie: isIE,
  },
};

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication(msalConfig);
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();

  // If a bypass-auth JWT is already in sessionStorage, skip the AAD token flow
  // entirely — BypassAuthInterceptorService attaches the bearer token instead.
  // Without this guard MsalInterceptor would still match apiUrl, call
  // acquireTokenSilent, fail (no MSAL account), and fall back to
  // interactive renewal → unwanted redirect away from the app despite bypass login.
  const hasBypassToken = typeof sessionStorage !== "undefined"
    && sessionStorage.getItem(GlobalConstants.bypassTokenStorageKey) !== null;

  if (!hasBypassToken) {
    protectedResourceMap.set(environment.apiUrl, [environment.msalConfig.scope]);
  }

  return {
    // Redirect, not Popup: when acquireTokenSilent fails MsalInterceptor falls back to
    // interactive renewal, and a popup raised outside a user gesture is blocked by the
    // browser - the request then fails client-side and never becomes an HTTP response
    // (AB#34659). Interactive login already uses loginRedirect.
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory() {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ['user.read']
    }
  };
}
